import app from "@/common/plugins/vueInstance";
import { TippyPlugin } from "tippy.vue";

import "tippy.js/dist/tippy.css";

app.use(TippyPlugin);
